import React, { useState } from "react";
import p1 from "../../assets/images/1.jpg";
import p2 from "../../assets/images/2.jpg";
import p3 from "../../assets/images/3.jpg";
import p4 from "../../assets/images/4.jpg";
import p5 from "../../assets/images/5.jpg";
import p6 from "../../assets/images/6.jpg";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

const Gallery = () => {
  const [images] = useState([
    { url: p1, title: "Main Entrance" },
    { url: p2, title: "Entry Way" },
    { url: p3, title: "Donation Box" },
    { url: p4, title: "Abulotion Area" },
    { url: p5, title: "Rest Room" },
    { url: p6, title: "Electrical Room" },
  ]);

  // Modern grid layout distribution classes
  const gridClasses = [
    "md:col-span-2 md:row-span-2 h-72 md:h-auto", // 1st image (Large feature)
    "h-72", // 2nd image (Standard)
    "h-72", // 3rd image (Standard)
    "md:col-span-2 h-72", // 4th image (Wide banner)
    "h-72", // 5th image (Standard)
    "h-72", // 6th image (Standard)
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-16">
      {/* Header Section */}
      <div className="text-center mb-12">
        <Fade direction="up" triggerOnce>
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight mb-3 text-green-950">
            Our Gallery
          </h2>
        </Fade>
        <p className="text-gray-500 max-w-md mx-auto mb-6">
          Explore a curated collection of beautiful moments captured through our
          lens.
        </p>
        <Link
          to="/gallery"
          className="inline-block px-6 py-2.5 bg-green-950 text-white font-medium rounded-full hover:bg-green-800 transition-all duration-300 transform hover:-translate-y-0.5 shadow-md hover:shadow-lg"
        >
          View Full Gallery
        </Link>
      </div>

      {/* Modern Bento Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 auto-rows-fr">
        {images.length > 0 ? (
          images.map((image, index) => (
            <div
              key={index}
              className={`group relative overflow-hidden rounded-2xl bg-gray-100 shadow-sm transition-all duration-500 hover:shadow-xl ${gridClasses[index % gridClasses.length]}`}
            >
              {/* Image with zoom effect */}
              <img
                src={image.url}
                alt={image.title || `Gallery ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />

              {/* Smooth Dark Gradient Overlay on Hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-5">
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white font-medium text-lg">
                    {image.title}
                  </p>
                  <p className="text-gray-300 text-xs uppercase tracking-wider">
                    View Image
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-full text-center py-20 text-gray-400 font-medium">
            Loading stunning visuals...
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
